<!-- 出库任务单 -->
<template>
    <div>
        <!-- 按钮组 -->
        <div class="buttons_box">
            <el-button type="primary" size="mini" class="mini_button">导入</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="saveOutboundForm">保存</el-button>
            <!-- <el-button type="primary" size="mini" class="mini_button" >删除</el-button> -->
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button> -->
            <!-- <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
        <el-form class="demo-form-inline outboundForm" :inline="true" ref="outboundForm" :model="outboundForm" size="mini" label-width="160px">
            <el-divider content-position="left">任务信息</el-divider>
                <el-form-item label="出库单号" prop="billNo"> 
                    <el-input disabled v-model="outboundForm.billNo"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="出库状态" prop="taskStatus"> 
                    <el-input disabled placeholder="" v-model="outboundForm.taskStatus"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="单证员" prop="createUser"> 
                    <el-input disabled v-model="outboundForm.createUser"  suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker disabled v-model="outboundForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width: 193px;"> </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker class="width_100" v-model="outboundForm.planDate" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 193px;"> </el-date-picker>
                </el-form-item>   
                <el-divider content-position="left">货物信息</el-divider>
                <el-form-item label="账册编号" prop="handbook">
                    <el-input disabled v-model="outboundForm.handbook" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName">
                    <el-input disabled v-model="outboundForm.ckName" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded">
                    <el-input disabled v-model="outboundForm.isBonded" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="货主" prop="ownerName">
                    <el-input disabled v-model="outboundForm.ownerName" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="提货方" prop="customer">
                    <el-select filterable placeholder="请选择提货方" v-model="outboundForm.customer">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出库提单号" prop="blNo">
                    <el-input v-model="outboundForm.blNo" placeholder="请输入出库提单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="出库报关单号" prop="cusDeclNo">
                    <el-input v-model="outboundForm.cusDeclNo" placeholder="请输入出库报关单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="出库核注清单号" prop="invDecNo">
                    <el-input v-model="outboundForm.invDecNo" placeholder="请输入出库核注清单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="箱型" prop="boxType">
                    <el-select placeholder="请选择箱型" v-model="outboundForm.boxType">
                        <el-option v-for="item in boxTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="箱量" prop="planDate">
                    <el-input suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="净重（总）" prop="netWeight">
                    <el-input disabled v-model="outboundForm.netWeight" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="件数1（总）" prop="qty1Sum">
                    <el-input disabled v-model="outboundForm.qty1Sum" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="outboundForm.remark" suffix-icon="xxxx" style="width: 920px;"> </el-input>
                </el-form-item>
        </el-form>
        <el-divider content-position="left">计划信息</el-divider>
        <div class="buttons_box" style="justify-content: space-between;">
            <div>
                <el-button type="primary" size="mini" class="mini_button" @click="IssueRowsSave">下发暂存</el-button>
                <el-button type="primary" size="mini" class="mini_button" @click="deleteOutboundPlan">删除</el-button>
                <el-button type="primary" size="mini" class="mini_button" @click="getIssueAll">查询全部下发任务</el-button>
            </div>
            <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
        </div>
        <!-- 计划信息列表 -->
        <vxe-table id="outboundPlanTable"  size="mini" ref="outboundPlanTable" :data="outboundPlanData" :columns="outboundColumns" border stripe
            :column-config="{resizable: true,sortable: true,drag:true}"  header-align="center" :custom-config="outboundCustomConfig" 
            :row-config="{ isHover: true}" :radio-config="{labelField: '', highlight: true}" @radio-change="outboundRowsChange"
            max-height="250">
                <!-- 列渲染 -->
                <vxe-column type="radio" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in outboundColumns" :field="column.field" :title="column.title" sortable >
                     <template #default="{ row, column }">
                        <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
        </vxe-table>
         <!--  -->
        <el-divider content-position="left" >库存信息</el-divider>
        <!-- 查询框 -->
        <el-form class="demo-form-inline" :inline="true" ref="inventorySeachForm" :model="inventorySeachForm" size="mini" label-width="20px">
            <el-form-item label=" " prop="blNo"> 
                <el-input placeholder="请输入提单号" v-model="inventorySeachForm.blNo" style="width: 300px;" ></el-input>
            </el-form-item>
            <el-form-item label=" " prop="cusDeclNo"> 
                <el-input placeholder="请输入报关单号" v-model="inventorySeachForm.cusDeclNo" style="width: 300px;" ></el-input>
            </el-form-item>
            <el-form-item label="" prop=""> 
                <el-button type="primary" size="mini" @click="inventorySeach">搜索</el-button>
            </el-form-item>
        </el-form>
        <!-- 库存信息列表 -->
        <vxe-table id="inventoryTable" size="mini" ref="inventoryTable" :data="inventoryList" border stripe max-height="250"
            :column-config="{resizable: true,sortable: true}" header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" >
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="blNo" title="提单号" width="100" fixed="left"></vxe-column>
            <vxe-column field="goodsName" title="货物名称" width="120" fixed="left"></vxe-column>
            <vxe-column field="ownerName" title="货主单位" width="170" fixed="left"></vxe-column>
            <vxe-column field="hsCode" title="海关编码" width="85"></vxe-column>
            <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
            <vxe-column field="totalQty1" title="件数1" width="100">
                <template #edit="{ row }">
                    <vxe-number-input v-model="row.totalQty1" type="number" placeholder="请输入数值"></vxe-number-input>
                </template>
            </vxe-column>
            <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
            <vxe-column field="totalQty2" title="件数2" width="100"></vxe-column>
            <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
            <vxe-column field="totalNetWeight" title="净重" width="100"></vxe-column>
            <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
            <vxe-column field="totalDecNum" title="申报数量" width="100"></vxe-column>
            <vxe-column field="lawUnitFirstName" title="法定第一单位" width="100"></vxe-column>
            <vxe-column field="totalFirstNum" title="法定第一数量" width="100"></vxe-column>
            <vxe-column field="lawUnitSecond" title="法定第二单位" width="100"></vxe-column>
            <vxe-column field="totalSecondNum" title="法定第二数量" width="100"></vxe-column>
            <vxe-column field="customer" title="委托单位" width="170"></vxe-column>
            <vxe-column field="goodsType" title="货物分类" width="70"></vxe-column>
            <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
            <vxe-column field="invDecNo" title="核注清单号" width="100"></vxe-column>
            <vxe-column field="cusDeclNo" title="报关单号" width="100"></vxe-column>
            <vxe-column field="skuNo" title="商品料号" width="100"></vxe-column>
            <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
            <vxe-column field="createDate" title="入库日期" width="100"></vxe-column>
            <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
            <vxe-column field="place" title="库区" width="100"></vxe-column>
            <vxe-column field="location" title="库位" width="100"></vxe-column>
            <!-- 操作列 -->
             <vxe-column title="操作" width="100" fixed="right">
                <template v-slot="scope"> 
                    <el-button type="primary" size="mini" @click="AddOutboundPlan(scope.row)">加入计划</el-button>
                </template>
             </vxe-column>
        </vxe-table>
        <el-divider content-position="left" >作业信息</el-divider>
        <!-- 作业信息列表 -->
         <vxe-table id="IssueGoodsTable"  size="mini" ref="IssueGoodsTable" :data="IssueGoodsData" border stripe
            :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" style="margin-top: 20px;" max-height="250">
                <!-- <vxe-column type="radio" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="rowStatus" title="作业状态" width="70"></vxe-column>
                <vxe-column field="taskNo" title="作业任务单号" width="130"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="120"></vxe-column>
                <vxe-column field="storekeeper" title="理货员"></vxe-column>
                <vxe-column field="goodsName" title="货物名称"></vxe-column>
                <vxe-column field="ckName" title="仓库"></vxe-column>
                <vxe-column field="place" title="库区"></vxe-column>
                <vxe-column field="location" title="库位"></vxe-column>
                <vxe-column field="driver" title="司机"></vxe-column>
                <vxe-column field="truckNo" title="车牌"></vxe-column>
                <vxe-colgroup title="任务数量">
                    <vxe-column field="netWeight" title="净重（KG）"></vxe-column>
                    <vxe-column field="qty1" title="件数1"></vxe-column>
                    <vxe-column field="qty1Unit" title="件数1单位"></vxe-column>
                    <vxe-column field="qty2" title="件数2"></vxe-column>
                    <vxe-column field="qty2Unit" title="件数2单位"></vxe-column>
                </vxe-colgroup>
                <vxe-column field="boxNo" title="箱号"></vxe-column>
                <vxe-column field="sealNo" title="铅封号"></vxe-column>
                <vxe-column field="createTime" title="创建时间" sortable  width="150"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
                <vxe-column title="操作" fixed="right" width="120">
                    <template #default="{ row }">
                        <el-button type="text" :disabled=" row.rowStatus !== '暂存' " size="mini" class="mini_button" @click="IssueRows(row)">下发</el-button>
                        <el-button type="text" :disabled=" row.rowStatus === '已下发' ? false : true"  size="mini" class="mini_button" @click="completeRows(row)">完成</el-button>
                    </template>
                </vxe-column>
            </vxe-table>
        <!-- 出库计划信息弹出框 -->
        <el-dialog title="出库计划信息" width="75%" :visible.sync="inventoryPlanVisible" :before-close="inventoryPlanClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-descriptions title="" :column="4" size="medium">
                <el-descriptions-item label="保税类型">{{ inventorySelected.isBonded }}</el-descriptions-item>
                <el-descriptions-item label="货物名称">{{ inventorySelected.goodsName }}</el-descriptions-item>
                <el-descriptions-item :span="2" label="规格型号">{{ inventorySelected.spec }}</el-descriptions-item>
                <el-descriptions-item label="货主单位">{{ inventorySelected.ownerName }}</el-descriptions-item>
                <el-descriptions-item label="提单号">{{ inventorySelected.blNo }}</el-descriptions-item>
                <el-descriptions-item label="报关单号">{{ inventorySelected.cusDeclNo }}</el-descriptions-item>
                <el-descriptions-item label="核注清单号">{{ inventorySelected.invDecNo }}</el-descriptions-item>
                <el-descriptions-item label="仓库">{{ inventorySelected.ckName }} - {{ inventorySelected.place }} - {{ inventorySelected.location }}</el-descriptions-item>
                <el-descriptions-item label="净重(KG)">{{ inventorySelected.totalNetWeight }}</el-descriptions-item>
                <el-descriptions-item label="申报数量">{{ inventorySelected.totalDecNum }} {{ inventorySelected.decUnitName }}</el-descriptions-item>
                <el-descriptions-item label="申报金额">{{ inventorySelected.totalDecAmount }} {{ inventorySelected.decCurrency }}</el-descriptions-item>
                <el-descriptions-item label="件数1">{{ inventorySelected.totalQty1 }} {{ inventorySelected.qty1UnitName }}</el-descriptions-item>
                <el-descriptions-item label="件数2">{{ inventorySelected.totalQty2 }} {{ inventorySelected.qty2UnitName }}</el-descriptions-item>
                <el-descriptions-item label="法定第一数量">{{ inventorySelected.totalFirstNum }} {{ inventorySelected.lawUnitFirstName }}</el-descriptions-item>
                <el-descriptions-item label="法定第二数量">{{ inventorySelected.totalSecondNum }} {{ inventorySelected.lawUnitSecondName }}</el-descriptions-item>
            </el-descriptions>
            <!-- 打开默认填写所有值，修改件数时同时修改净重和申报数量和申报金额 -->
            <el-form class="demo-form-inline" :inline="true" ref="inventoryPlanForm" :model="inventoryPlanForm" size="mini" label-width="120px"
            :rules="inventoryPlanRules">
                <el-form-item label="件数1" prop="qty1"> 
                    <el-input  v-model="inventoryPlanForm.qty1" @blur="qty1Blur"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="件数2" :prop="inventorySelected.totalQty2? 'qty2':''" > 
                    <el-input :disabled="!inventorySelected.totalQty2" v-model="inventoryPlanForm.qty2"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="净重(KG)" prop="netWeight"> 
                    <el-input v-model="inventoryPlanForm.netWeight"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报数量" :prop="inventorySelected.totalDecNum? 'decNum':''" > 
                    <el-input :disabled="!inventorySelected.totalDecNum" v-model="inventoryPlanForm.decNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第一数量" :prop="inventorySelected.totalFirstNum? 'firstNum':''"> 
                    <el-input :disabled="!inventorySelected.totalFirstNum" v-model="inventoryPlanForm.firstNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第二数量" :prop="inventorySelected.totalSecondNum? 'secondNum':''" > 
                    <el-input :disabled="!inventorySelected.totalSecondNum" v-model="inventoryPlanForm.secondNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报金额" :prop="inventorySelected.totalDecAmount? 'decAmount':''"> 
                    <el-input :disabled="!inventorySelected.totalDecAmount" v-model="inventoryPlanForm.decAmount"  suffix-icon="xxxx"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddInventoryPlan">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 下发暂存弹出框 -->
         <el-dialog title="任务下发" width="75%" :visible.sync="IssueGoodsVisible" :before-close="IssueGoodsClose" v-dialogDrag
             :close-on-click-modal="false">
             <!-- 显示货物信息 -->
                <el-descriptions   :column="5">
                    <!-- 显示的时候使用选中行数据inWarehouseRows -->
                    <el-descriptions-item label="货物名称">{{ inventoryPlanRow.goodsName }}</el-descriptions-item>
                    <el-descriptions-item label="货物分类">{{ inventoryPlanRow.goodsType }}</el-descriptions-item>
                    <el-descriptions-item label="海关编码">{{  inventoryPlanRow. hsCode }}</el-descriptions-item>
                    <el-descriptions-item :span="2" label="规格型号">{{  inventoryPlanRow.spec }}</el-descriptions-item>
                    <el-descriptions-item label="库区库位">{{  inventoryPlanRow.place }} - {{  inventoryPlanRow.location }}</el-descriptions-item>
                    <el-descriptions-item label="包装">{{  inventoryPlanRow.packageType }}</el-descriptions-item>
                    <el-descriptions-item label="件数1">{{  inventoryPlanRow.qty1 }}  {{ inventoryPlanRow.qty1UnitName }} </el-descriptions-item>
                    <el-descriptions-item label="件数2">{{  inventoryPlanRow.qty2 }}  {{  inventoryPlanRow.qty2UnitName }}  </el-descriptions-item>
                    <el-descriptions-item label="净重（KG）">{{  inventoryPlanRow.netWeight }}</el-descriptions-item>
                    <el-descriptions-item label="申报数量">{{  inventoryPlanRow.decNum }}  {{  inventoryPlanRow.decUnitName }} </el-descriptions-item>
                    <el-descriptions-item label="单价">{{  inventoryPlanRow.decPrice }}</el-descriptions-item>
                    <el-descriptions-item label="申报金额">{{  inventoryPlanRow.decAmount }}  {{  inventoryPlanRow.decCurrencyName }} </el-descriptions-item>
                    <!-- <el-descriptions-item label="原产地">{{  inventoryPlanRow.originCountryName }}</el-descriptions-item> -->
                    <el-descriptions-item label="法定第一数量">{{  inventoryPlanRow.firstNum }}  {{  inventoryPlanRow.lawUnitFirstName }}  </el-descriptions-item>
                    <el-descriptions-item label="法定第二数量">{{  inventoryPlanRow.secondNum }}  {{  inventoryPlanRow.lawUnitSecondName }} </el-descriptions-item>
                </el-descriptions>
                <!-- 下发填写表单 -->
                <el-divider content-position="left">下发信息</el-divider>
                <el-form :model="issueGoodsForm" ref="issueGoodsForm" class="demo-form-inline " size="mini" label-width="80px"
                :rules="issueGoodsFormRules">
                    <el-row>
                        <el-col :span="6">
                             <el-form-item label="理货员" prop="storekeeper">
                                <el-select class="width_100"  v-model="issueGoodsForm.storekeeper" placeholder="请选择理货员" >
                                    <el-option v-for="item in storekeeperList"  :key="item.name" :label="item.name " :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="司机" prop="driver">
                                <el-input v-model="issueGoodsForm.driver" placeholder="请输入司机"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="车牌" prop="truckNo">
                                <el-input v-model="issueGoodsForm.truckNo" placeholder="请输入车牌"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="箱号" prop="boxNo">
                                <el-input v-model="issueGoodsForm.boxNo" placeholder="请输入箱号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="铅封号" prop="sealNo">
                                <el-input v-model="issueGoodsForm.sealNo" placeholder="请输入铅封号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="件数1" prop="qty1">
                                <el-input class="form_item_60"  v-model="issueGoodsForm.qty1" placeholder="请输入件数1"
                                  onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" @blur="blurIssGoodsQty1"></el-input>
                                <span class="tipText">已下发：{{ inventoryPlanRow.workedQty1  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数2" :prop="inventoryPlanRow.qty2 ? 'qty2':''">
                                <el-input :disabled="inventoryPlanRow.qty2 ? false:true" class="form_item_60" 
                                v-model="issueGoodsForm.qty2" placeholder="请输入件数2"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                <span class="tipText">已下发：{{ inventoryPlanRow.workedQty2  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="净重" prop="netWeight">
                                <el-input class="form_item_60" v-model="issueGoodsForm.netWeight" placeholder="请输入净重"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                <span class="tipText">已下发：{{ inventoryPlanRow.workedNetWeight  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报数量" :prop="inventoryPlanRow.decNum ? 'decNum':''" >
                                <el-input class="form_item_60" v-model="issueGoodsForm.decNum" placeholder="请输入申报数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" :disabled="inventoryPlanRow.decNum ? false:true"></el-input>
                                <span class="tipText">已下发：{{ inventoryPlanRow.workedDecNum  }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="申报金额" :prop="inventoryPlanRow.decAmount ? 'decAmount':''" >
                                <el-input class="form_item_60" v-model="issueGoodsForm.decAmount" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" 
                                 :disabled="inventoryPlanRow.decAmount ? false:true" placeholder="请输入申报金额"></el-input>
                                  <span class="tipText">已下发：{{ inventoryPlanRow.workedAmount  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法一数量" :prop="inventoryPlanRow.firstNum ? 'firstNum':''" >
                                <el-input class="form_item_60" v-model="issueGoodsForm.firstNum" placeholder="请输入法一数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"  :disabled="inventoryPlanRow.firstNum ? false:true"></el-input>
                                <span class="tipText">已下发：{{ inventoryPlanRow.workedFirstNum  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法二数量" :prop="inventoryPlanRow.secondNum ? 'secondNum':''">
                                  <el-input :disabled="inventoryPlanRow.secondNum ? false:true" class="form_item_60" 
                                  v-model="issueGoodsForm.secondNum" placeholder="请输入法二数量"
                                  onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                  <span class="tipText">已下发：{{ inventoryPlanRow.workedSecondNum  }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="IssueGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveIssueGoods">保 存</el-button>
                </span>
            </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import AEObasicData from '@/config/AEObasicData.js'
import { set } from 'nprogress';
export default {
    name: 'outbound',
    mixins: [userProfile],
    components:{
    },
    watch: { 
    },
    data() {
        // 自定义验证函数  件数1出库计划
        const validateQty1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalQty1) {
                return callback(new Error(`件数1不能超过 ${this.inventorySelected.totalQty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数2出库计划
        const validateQty2 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalQty2) {
                return callback(new Error(`件数2不能超过 ${this.inventorySelected.totalQty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  净重出库计划
        const validateNetWeight = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalNetWeight) {
                return callback(new Error(`净重不能超过 ${this.inventorySelected.totalNetWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报数量出库计划
        const validateDecNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalDecNum) {
                return callback(new Error(`申报数量不能超过 ${this.inventorySelected.totalDecNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法1出库计划
        const validateFirstNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalFirstNum) {
                return callback(new Error(`法定第一数量不能超过 ${this.inventorySelected.totalFirstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法2出库计划
        const validateSecondNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalSecondNum) {
                return callback(new Error(`法定第二数量不能超过 ${this.inventorySelected.totalSecondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报金额出库计划
        const validateDecAmount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalDecAmount) {
                return callback(new Error(`申报金额不能超过 ${this.inventorySelected.totalDecAmount}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数1下发暂存
        const validateQty1IssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.qty1) {
                return callback(new Error(`件数1不能超过 ${this.inventoryPlanRow.qty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数2下发暂存
        const validateQty2IssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.qty2) {
                return callback(new Error(`件数1不能超过 ${this.inventoryPlanRow.qty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  净重下发暂存
        const validateNetWeightIssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.netWeight) {
                return callback(new Error(`净重不能超过 ${this.inventoryPlanRow.netWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报数量下发暂存
        const validateDecNumIssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.decNum) {
                return callback(new Error(`申报数量不能超过 ${this.inventoryPlanRow.decNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法1下发暂存
        const validateFirstNumIssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.firstNum) {
                return callback(new Error(`法定第一数量不能超过 ${this.inventoryPlanRow.firstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法2下发暂存
        const validateSecondNumIssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.secondNum) {
                return callback(new Error(`法定第二数量不能超过 ${this.inventoryPlanRow.secondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报金额下发暂存
        const validateDecAmountIssueGoods = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRow.decAmount) {
                return callback(new Error(`申报金额不能超过 ${this.inventoryPlanRow.decAmount}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        return{
            outboundCustomConfig:null, // 自定义表格配置
            outboundForm:{ // 表头
                id:'', 
                taskType: '出库', // 出入库类型
                billNo:'', // 入库单号
                taskStatus:'新建', // 状态
                createUser:'', // 单证人
                createDate:'', // 创建日期
                planDate:'', // 计划作业日期
                blNo:'', // 出库提单号
                isBonded:'' , // 保税属性
                handbook:'' , // 账册编号
                cusDeclNo:'', // 出库报关单号
                invDecNo:'', // 出库核注清单号
                customer:'', // 提货方
                ownerName:'', // 货主单位
                ckName:'', // 仓库
                boxType:'', // 箱型
                boxNum:'', // 箱量
                // grossWeight:'', // 毛重(总)
                netWeight:'', // 净重(总)
                qty1Sum:'', // 件数1(总)
                qty2Sum:'', // 件数2(总)
                // volume:'', // 体积(总)
            },// 出库表头
            inventorySeachForm:{
                blNo:'', // 提单号
                cusDeclNo:'', // 报关单号
                ownerName:'', // 货主
                isBonded:'', // 保税类型
                ckName:'', // 仓库
            },
            hasHandledToken: false, // 是否处理过token
            customerList:[], // 客户列表
            boxTypeList:[], // 箱型列表
            inventoryList:[], // 库存列表
            currencyList:AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制列表
            inventorySelected:{}, // 选中库存信息
            inventoryPlanVisible:false, // 库存信息弹出框
            inventoryPlanForm:{}, // 出库计划输入信息
            outboundPlanData:[], // 出库计划表格
            inventoryPlanRow:{}, // 选中计划信息表格行
            issueGoodsForm:{
                taskType:'出库作业', // 任务类型
                storekeeper:'', // 理货员
                firstNum:'', // 法一数量
                secondNum:'', // 法二数量
                netWeight:'', // 净重
                qty1:'', // 件1
                qty2:'', // 件2
                decNum:'', // 申报数量
                decAmount:0, // 申报金额
                driver:'', // 司机
                truckNo :'', // 车牌
                sealNo:'', // 铅封号
                boxNo:'', // 箱号
            }, // 下发作业填写表单
            IssueGoodsVisible:false, // 下发弹出框显示
            IssueGoodsData:[], // 下发任务表格
            storekeeperList:[
                {
                    name:'孙志军'
                },{
                    name:'李永亮'
                }
            ], // 理货员列表
            qtyUnitList:AEObasicData.CUS_UNIT, // 计量单位, // 件数单位
            //实际使用的列配置（从本地存储恢复或用默认）
            outboundColumns:[],
            // 出库计划验证规则
            inventoryPlanRules:{
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2, trigger: "blur" }
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeight, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNum, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNum, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNum, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmount, trigger: "blur" }
                ],
            },
            // 下发暂存验证规则
            issueGoodsFormRules:{
                storekeeper:[
                    { required: true, message: '请选择理货员', trigger: 'change' }
                ],
                driver:[
                    { required: true, message: '请输入司机', trigger: 'blur' },
                ],
                truckNo:[
                    { required: true, message: '请输入车牌', trigger: 'blur' },
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeightIssueGoods, trigger: "blur" }
                ],
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1IssueGoods, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2IssueGoods, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNumIssueGoods, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmountIssueGoods, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNumIssueGoods, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNumIssueGoods, trigger: "blur" }
                ],
            },
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.outboundCustomConfig = this.customConfig // 表格定义列
                    this.getCompanyList()
                    this.getBoxTypeList()
                    this.getWMSTaskDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
         this.outboundForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
    },
    methods: {
        // 接收父窗口的消息
        handleMessage(event) {
            if (event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                this.hasHandledToken = true;
                console.log('接收到来自子窗口的消息：', event.data);
                localStorage.setItem('token', event.data.token);
                localStorage.setItem('name', event.data.name);
                // 向父窗口发送消息
                event.source.postMessage(
                    { type: 'TOKEN_RECEIVED' },
                    event.origin
                );
                Promise.resolve().then(() => {
                    this.outboundCustomConfig = this.customConfig // 表格定义列
                    this.getCompanyList()
                    this.getBoxTypeList()
                    if(event.data.id !== ''){
                        localStorage.setItem('id', event.data.id);
                        this.getWMSTaskDetail(localStorage.getItem('id'))
                    }else{
                        this.outboundForm.createUser = event.data.name
                    }
                })
            }
        },
        // 查询任务详情
        async getWMSTaskDetail(id){
            this.$api.getWMSTaskDetail(id).then(res =>{
                this.outboundForm = res.taskMain
                //查询inWarehouseData中编码对应的汉字
                this.outboundPlanData = this.processTableData(res.taskSub.tableData);
                this.outboundColumns = res.taskSub.columns
            })
        },
        // 通用查找方法
        findNameByCode(code, list) {
            if (!code) return '';
            const item = list.find(item => item.codeValue === code);
            return item ? item.codeName : code; // 找不到就返回原编码
        },
        // 处理整个数组的数据转换
        processTableData(data) {
            return data.map(item => ({
            ...item,
            decCurrencyName: this.findNameByCode(item.decCurrency, this.currencyList), // 币制
            // originCountryName: this.findNameByCode(item.originCountry, AEObasicData.CUS_MAPPING_COUNTRY_CODE_V), // 原产地
            lawUnitFirstName: this.findNameByCode(item.lawUnitFirst, AEObasicData.CUS_UNIT), // 法一单位
            lawUnitSecondName: this.findNameByCode(item.lawUnitSecond, AEObasicData.CUS_UNIT), // 法二单位
            decUnitName: this.findNameByCode(item.decUnit, AEObasicData.CUS_UNIT), // 申报单位
            qty1UnitName: this.findNameByCode(item.qty1Unit, this.qtyUnitList), // 件数1单位
            qty2UnitName: this.findNameByCode(item.qty2Unit, this.qtyUnitList), // 件数2单位
            // packageTypeName: this.findNameByCode(item.packageType, this.lawUnitList), // 包装
            }));
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取箱型列表
        getBoxTypeList(){
            this.$api.getDicList( { value:'箱型'} ).then(res =>{
                this.boxTypeList = res
            })
        },
        // 搜索库存信息
        inventorySeach(){
            // 提单号必填
            if(this.inventorySeachForm.blNo === '' &&  this.inventorySeachForm.cusDeclNo === ''){
                this.$message.error('请填写提单号/报关单号')
                return
            }
            this.inventorySeachForm.ownerName = this.outboundForm.ownerName
            this.inventorySeachForm.isBonded = this.outboundForm.isBonded
            this.inventorySeachForm.ckName = this.outboundForm.ckName
            this.$api.wmsGetStockList( this.inventorySeachForm ).then(res =>{
                this.inventoryList = res
            })
        },
        // 保存表头
        async saveOutboundForm(){
            // 判断是否有单号，没有单号先获取单号
            if(!this.outboundForm.billNo){
                await this.getWMSBillNo()
                // 保存表头
                await this.outboundSaveMain()
            }else{
                this.outboundSaveMain()
            }
        },
        // 获取出库单号
        async getWMSBillNo() {
            try {
                const res = await this.$api.getWMSBillNo('CK');
                this.outboundForm.billNo = res;
                return res; // 这里返回获取到的单号
            } catch (error) {
                throw error; // 抛出错误让外层捕获
            }
        },
        // 保存表头
        async outboundSaveMain(){
            const res = await this.$api.saveMain(this.outboundForm);
            if (localStorage.getItem('id')) {
                localStorage.setItem('id', res);
            }
            // 等待查询详情完成
            await this.getWMSTaskDetail(res);
            this.$message.success('保存成功');
        },
        // 将库存添加到出库计划
        AddOutboundPlan(data){
            // 弹出框写出库信息
            this.inventorySelected = data
            // inventoryPlanForm默认赋值选中数据
            this.inventoryPlanForm = {
                qty1: this.inventorySelected.totalQty1,
                qty2:   this.inventorySelected.totalQty2,
                netWeight:  this.inventorySelected.totalNetWeight,
                decNum: this.inventorySelected.totalDecNum,
                decAmount:  this.inventorySelected.totalDecAmount,
                firstNum: this.inventorySelected.totalFirstNum,
                secondNum: this.inventorySelected.totalSecondNum,
            }
            this.inventoryPlanVisible = true
        },
        // 当出库计划中的件数1发生改变时，同时改件数2，净重，申报数量，金额
        qty1Blur(){
            // 净重
            this.inventoryPlanForm.netWeight = this.calculateAllPlanFields(this.inventorySelected.totalNetWeight,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.qty2 = this.calculateAllPlanFields(this.inventorySelected.totalQty2,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.decNum = this.calculateAllPlanFields(this.inventorySelected.totalDecNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.decAmount = this.calculateAllPlanFields(this.inventorySelected.totalDecAmount,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.firstNum = this.calculateAllPlanFields(this.inventorySelected.totalFirstNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.secondNum = this.calculateAllPlanFields(this.inventorySelected.totalSecondNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
        },  
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1All,qty1Actual){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1All); // 选中数据的件数1
                const planQty1 = Number(qty1Actual); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 关闭出库计划弹出框
        inventoryPlanClose(){
            this.inventoryPlanVisible = false
            this.inventorySelected = {}
            this.inventoryPlanForm = {}
            this.$refs.inventoryPlanForm.resetFields();
        },
        // 确定添加出库计划
        async saveAddInventoryPlan(){
            try {
                const valid = await new Promise((resolve) => {
                    this.$refs.inventoryPlanForm.validate((valid) => {
                        resolve(valid);
                    });
                });
                if (!valid) {
                    this.$message.error('请填写必填字段');
                    return false;
                }
                // 判断是否保存表头，没保存则先保存表头，保存表头后保存表体
                if( this.outboundForm.billNo === ''){
                    this.outboundForm.billNo = await this.getWMSBillNo()
                }
                // 判断表头的账册、仓库、保税类型、货主是否有值
                if (this.outboundForm.handbook === '' && this.outboundForm.ckName === '' && this.outboundForm.isBonded === '' && 
                    this.outboundForm.ownerName === '') {
                    this.outboundForm.handbook = this.inventorySelected.handbook
                    this.outboundForm.ckName = this.inventorySelected.ckName
                    this.outboundForm.isBonded = this.inventorySelected.isBonded
                    this.outboundForm.ownerName = this.inventorySelected.ownerName
                    // 等待保存表头完成
                    const res = await this.$api.saveMain(this.outboundForm);
                    this.outboundForm.id = res
                    if (localStorage.getItem('id')) {
                        localStorage.setItem('id', res);
                    }
                }
                // 保存表头后保存出库计划
                const params = {
                    rowStatus: '', // 状态   
                    blNo: this.inventorySelected.blNo, // 提单号
                    interId: this.outboundForm.id, // 父id
                    goodsType: this.inventorySelected.goodsType, // 货物类型
                    hsCode: this.inventorySelected.hsCode, // 海关编码
                    goodsName: this.inventorySelected.goodsName, // 货物名称
                    spec: this.inventorySelected.spec, // 规格型号
                    ownerName: this.inventorySelected.ownerName, // 货主
                    ckName: this.inventorySelected.ckName, // 仓库
                    place: this.inventorySelected.place, // 库区
                    location: this.inventorySelected.location, // 库位
                    qty1Unit: this.inventorySelected.qty1Unit, // 件数1单位
                    qty2Unit: this.inventorySelected.qty2Unit, // 件数2单位
                    // packageType:this.inventorySelected.packageType, // 包装   库存没包装
                    decUnit: this.inventorySelected.decUnit, // 申报单位代码
                    decCurrency: this.inventorySelected.decCurrency, // 币制
                    stockDate:this.inventorySelected.createDate ,// 入库日期
                    // originCountry:'', // 原产地 库存没有原产地
                    lawUnitFirst: this.inventorySelected.lawUnitFirst, // 法一单位
                    lawUnitSecond: this.inventorySelected.lawUnitSecond, // 法二单位
                    // itemNo:'', // 项号
                    skuNo: this.inventorySelected.skuNo, // 商品料号
                    qty1: this.inventoryPlanForm.qty1,
                    qty2: this.inventoryPlanForm.qty2,
                    decAmount: this.inventoryPlanForm.decAmount, // 总价（申报金额）
                    netWeight: this.inventoryPlanForm.netWeight, // 净重
                    decNum: this.inventoryPlanForm.decNum, // 申报数量
                    firstNum: this.inventoryPlanForm.firstNum ? this.inventoryPlanForm.firstNum : '', // 法一数
                    secondNum: this.inventoryPlanForm.secondNum ? this.inventoryPlanForm.secondNum : '', // 法二数
                }
                const res = await this.$api.insOneRecordWMSTask(params);
                console.log(res);
                this.$message.success('保存成功');
                // 扣除库存
                await this.wmsOutStock();
                // 并行执行查询操作
                await Promise.all([
                    setTimeout(() => {
                        this.getWMSTaskDetail(this.outboundForm.id),
                        this.inventorySeach()
                    }, 500),
                ]);
                // 关闭弹窗
                this.inventoryPlanClose();
            } catch (error) {
                this.$message.error('保存失败');
            }
        },
        // 扣除库存
        wmsOutStock(){
            const params = {
                // 提单号，货物名称、规格型号、货主、仓库、库区、库位
                blNo:this.inventorySelected.blNo,
                goodsName:this.inventorySelected.goodsName,
                spec:this.inventorySelected.spec,
                ownerName:this.inventorySelected.ownerName,
                ckName:this.inventorySelected.ckName,
                place:this.inventorySelected.place,
                location:this.inventorySelected.location,
                qty1: this.inventoryPlanForm.qty1,
                qty2: this.inventoryPlanForm.qty2,
                decAmount: this.inventoryPlanForm.decAmount, // 总价（申报金额）
                netWeight: this.inventoryPlanForm.netWeight, // 净重
                decNum: this.inventoryPlanForm.decNum, // 申报数量
                firstNum: this.inventoryPlanForm.firstNum ? this.inventoryPlanForm.firstNum : '', // 法一数calculate All Plan FieldsIssueGoods
                secondNum: this.inventoryPlanForm.secondNum ? this.inventoryPlanForm.secondNum : '', // 法二数
            }
            this.$api.wmsOutStock(params).then(res =>{
            })
        },
        // 选中计划信息
        outboundRowsChange({row}){
            this.inventoryPlanRow = row
            // 查询下发任务列表
            this.wmsGetOpsBySubId(row.id)
        },
        // 查询下发任务列表，单个
        wmsGetOpsBySubId(id){
            this.$api.wmsGetOpsBySubId(id).then(res =>{
                this.IssueGoodsData = res
            })
        },
        // 查询所有下发任务
        getIssueAll(){
            this.$api.wmsGetOpsByTaskId(this.outboundForm.id).then(res =>{
                this.IssueGoodsData = res
                // 货物信息列表取消选中
                this.$refs.outboundPlanTable.clearRadioRow()
                this.inventoryPlanRow = {}
            })
        },
        // 下发暂存
        IssueRowsSave(){
            // 判断是否选中行数据
            if( !this.inventoryPlanRow.id ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            if(this.inventoryPlanRow.rowStatus === '已指派' ||  this.inventoryPlanRow.rowStatus === '完成' ){ 
                this.$message({
                    message: '此计划信息不可下发暂存',
                    type: 'warning'
                });
                return false
            }
            this.IssueGoodsVisible = true
            // 将下发信息的净重和件数修改为可以下发的最大值
            this.issueGoodsForm.netWeight = parseFloat(this.inventoryPlanRow.netWeight) - parseFloat(this.inventoryPlanRow.workedNetWeight)
            this.issueGoodsForm.qty1 = parseFloat(this.inventoryPlanRow.qty1) - parseFloat(this.inventoryPlanRow.workedQty1)
            this.issueGoodsForm.qty2 = this.inventoryPlanRow.qty2 ? parseFloat(this.inventoryPlanRow.qty2) - parseFloat(this.inventoryPlanRow.workedQty2): ''
            this.issueGoodsForm.decNum = this.inventoryPlanRow.decNum ? parseFloat(this.inventoryPlanRow.decNum) - parseFloat(this.inventoryPlanRow.workedDecNum) :''
            this.issueGoodsForm.decAmount = this.inventoryPlanRow.decAmount ? parseFloat(this.inventoryPlanRow.decAmount) - parseFloat(this.inventoryPlanRow.workedAmount) :''
            this.issueGoodsForm.firstNum = this.inventoryPlanRow.firstNum ? parseFloat(this.inventoryPlanRow.firstNum) - parseFloat(this.inventoryPlanRow.workedFirstNum) :''
            this.issueGoodsForm.secondNum =  this.inventoryPlanRow.secondNum ? parseFloat(this.inventoryPlanRow.secondNum) - parseFloat(this.inventoryPlanRow.workedSecondNum) :''
        },
        // 下发暂存输入件数1后，修改净重\件数2、申报数量、法一、法二、申报金额
        blurIssGoodsQty1(){
            this.issueGoodsForm.qty2 = this.calculateAllPlanFields(this.inventoryPlanRow.qty2,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
            this.issueGoodsForm.netWeight = this.calculateAllPlanFields(this.inventoryPlanRow.netWeight,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
            this.issueGoodsForm.decNum = this.calculateAllPlanFields(this.inventoryPlanRow.decNum,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
            this.issueGoodsForm.decAmount = this.calculateAllPlanFields(this.inventoryPlanRow.decAmount,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
            this.issueGoodsForm.firstNum = this.calculateAllPlanFields(this.inventoryPlanRow.firstNum,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
            this.issueGoodsForm.secondNum = this.calculateAllPlanFields(this.inventoryPlanRow.secondNum,this.inventoryPlanRow.qty1,this.issueGoodsForm.qty1)
        },

        // 关闭下发暂存弹出框
        IssueGoodsClose(){
            this.$refs.issueGoodsForm.resetFields();
            this.IssueGoodsVisible = false
        },
        // 保存下发暂存任务弹窗
        saveIssueGoods(){
            // 判断
            this.$refs.issueGoodsForm.validate((valid) => {
                if (valid) {
                    // 删除id，worked
                    const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                        completeDate,completeTime,createDate,createTime,rowStatus,  ...param } = this.inventoryPlanRow
                    // 合并 issueGoodsForm
                    Object.assign(param, this.issueGoodsForm);
                    param.interId = this.inventoryPlanRow.id
                    // 将仓库,报关单号,核注清单号,客户,货主赋值给param
                    param.ckName = this.outboundForm.ckName
                    param.cusDeclNo = this.outboundForm.cusDeclNo
                    param.invDecNo = this.outboundForm.invDecNo
                    param.customer = this.outboundForm.customer
                    param.ownerName = this.outboundForm.ownerName
                    param.handbook = this.outboundForm.handbook
                    param.isBonded = this.outboundForm.isBonded
                    this.$api.wmsSaveOpTask( param ).then(res =>{
                        // 关闭弹窗
                        this.IssueGoodsClose()
                        // 重新查询主任务
                        this.getWMSTaskDetail(this.outboundForm.id)
                        // 查询下发任务列表
                        this.wmsGetOpsBySubId(param.interId)
                        // 清空表格选中
                        this.inventoryPlanRow = {}
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 删除出库计划
        async deleteOutboundPlan(){
              // 判断是否选中行数据
            if( !this.inventoryPlanRow.id ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
             // 判断选中计划信息是否可以下发暂存
            if(this.inventoryPlanRow.rowStatus !== '新建' ){ 
                this.$message({
                    message: '此计划信息不可删除',
                    type: 'warning'
                });
                return false
            }
            this.$confirm('是否删除此计划?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsRemoveDetailById(this.inventoryPlanRow.id).then( async res =>{
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    // 取消选中信息行
                    this.inventoryPlanRow = {}
                    // 刷新页面
                    await this.getWMSTaskDetail(this.outboundForm.id)
                    // 刷新库存 如果库存查询中输入提单号或报关单号就查，否则不查
                    if(this.inventorySeachForm.blNo === '' &&  this.inventorySeachForm.cusDeclNo === ''){
                        return
                    }else{
                        await this.inventorySeach()
                    }
                })
            })
        },
        // 下发任务到手持端
        IssueRows(row){
            this.$confirm('是否推送作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmspushOpTask(row.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                })
            }).catch(() => {      
            });
        },
        // 完成入库
        completeRows(row){
            this.$confirm('是否确认完成此作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsinBoundTask(row).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '作业任务已成功'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                    this.getWMSTaskDetail(this.outboundForm.id)
                })
            }).catch(() => {      
            });
        },
    },
    destroyed() {
        window.removeEventListener('message', this.handleMessage);
        // 清空所有 localStorage
        localStorage.clear();
        console.log('LocalStorage 已清空');
    },
}
</script>
<style style lang="less" scoped>
.width_100{
    width: 100%;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
.mini_button{
    padding: 3px 8px !important;
}
.outboundForm{
    margin: 10px;
}
.form_item_60{
    width: 60%;
}
</style>